import { VerificationServiceCreateMethodTypes } from "@enums/verification-service-create-method-types";
import { SelectOption } from "@idw-types/common";

export const VERIFICATION_SERVICE_CREATE_METHOD_OPTIONS: Array<SelectOption> = [
    { 
        label: "Create a new Verification Service using a template",
        value: VerificationServiceCreateMethodTypes.USE_TEMPLATE
    },
    {
        label: "Create a blank Verification Service, I will configure it myself",
        value: VerificationServiceCreateMethodTypes.USE_BLANK
    },
    {
        label: "Create a new Verification Service from an import file",
        value: VerificationServiceCreateMethodTypes.USE_IMPORT
    },
    {
        label: "Create a copy of an existing Verification Service",
        value: VerificationServiceCreateMethodTypes.USE_COPY
    }
];